
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/electric-cars",
      function () {
        return require("private-next-pages/guides/electric-cars/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/electric-cars"])
      });
    }
  